import Button from '../../../../../../components/buttons/Button';
import React from 'react';
import { isEmpty } from 'lodash';
import { getElementIdsForUpdate, getHighestTagBoardId, partitionTagRootsByEditability } from '../tagUtils';
import { deleteTag, updateTag } from '../../../../../../../common/tags/tagActions';
import { replaceTagIdForElementsThunk } from '../tagThunks';
import { useDispatch } from 'react-redux';
import {
    BoardVirtualPathMap,
    TaggedElementsData,
} from '../../../../../../../common/api/tags/tagElementsRetrievalRouteTypes';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

type Props = {
    tag: Tag | null;
    closePopups: () => void;
    taggedElements: TaggedElementsData[] | null;
    userRootPath: ImMNElement[] | null;
    boardVirtualPathToRootMap: BoardVirtualPathMap | null;
    translate: (key: string, options?: Record<string, any>) => string;
};

const TagDeleteButton = (props: Props) => {
    const { tag, closePopups, taggedElements, userRootPath, boardVirtualPathToRootMap, translate } = props;

    const dispatch = useDispatch();

    const elementCount = isEmpty(taggedElements) || !taggedElements ? 0 : taggedElements.length;

    const deleteTagHandler = () => {
        if (!tag || !userRootPath || !boardVirtualPathToRootMap) return;

        // Check if all tag roots fall under the current highest tag root
        const { tagRootsNotToUpdate } = partitionTagRootsByEditability(tag, userRootPath, boardVirtualPathToRootMap);

        // If so, make the update
        if (tagRootsNotToUpdate.length === 0) {
            dispatch(deleteTag(tag.id));
            closePopups();
            return;
        }

        // if not,
        // Remove those tag roots from the old tag
        dispatch(updateTag(tag.id, { rootBoardIds: tagRootsNotToUpdate }));

        // Remove the tag id from all tagged elements for those roots

        const highestRootId = getHighestTagBoardId(tag, userRootPath);
        const elementIdsForUpdate = getElementIdsForUpdate(
            taggedElements || [],
            highestRootId,
            boardVirtualPathToRootMap,
        );
        dispatch(replaceTagIdForElementsThunk(elementIdsForUpdate, tag.id));
        closePopups();
    };

    return (
        <Button className="flex w-48 !mx-6 !py-1 !px-4 hover:!bg-gray-100" onClick={deleteTagHandler}>
            <div className="flex w-full items-center justify-between gap-4">
                <span>{translate('delete')}</span>
                {elementCount > 0 && (
                    <span className="text-xs text-gray-400">{translate('used', { count: elementCount })}</span>
                )}
            </div>
        </Button>
    );
};

export default TagDeleteButton;
